import { Link } from 'react-router-dom'
import { NotFoundView } from '@loop3/ui'

export function NotFoundPage() {
  return <NotFoundView homeLink={<Link to="/" />} homeLabel="Back to Home" />
}
